<template>
  <b-card-text>
    <div class="filterwrapper d-flex align-items-center flex-wrap gap-3">
      <!-- Search Input -->
      <div class="search_input_wrapper position-relative" v-if="tabIndex">
        <b-skeleton v-if="isFilterSkeleton" type="text" width="200px" height="38px"></b-skeleton>
        <template v-else>
          <input
            type="text"
            class="form-control border-0 font-14"
            placeholder="Enter Submitter Name"
            v-model="searchTerm"
          />
          <div class="iconwrapper position-absolute clr-bold-grey">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
              <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14"/>
            </svg>
          </div>
        </template>
      </div>

      <!-- Status Dropdown -->
      <template v-if="isFilterSkeleton">
        <b-skeleton type="text" width="150px" height="38px"></b-skeleton>
      </template>
      <template v-else>
        <b-dropdown variant="light" class="filterdropdownwrapper" menu-class="w-100">
          <template #button-content>
            <span class="dropdownlabel clr-bold-grey fw-normal font-14">
              <span class="mr-1 fw-medium">Status:</span>
              {{ selectedStatus }}
            </span>
            <div class="icon clr-bold-grey">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/>
              </svg>
            </div>
          </template>
          <b-dropdown-item
            v-for="status in statusOptions"
            :key="status"
            @click="selectedStatus = status"
            :active="selectedStatus === status"
            class="font-14"
          >
            {{ status }}
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- Category Dropdown -->
      <template v-if="isFilterSkeleton">
        <b-skeleton type="text" width="150px" height="38px"></b-skeleton>
      </template>
      <template v-else>
        <b-dropdown variant="light" class="filterdropdownwrapper" menu-class="custom-scrollable-dropdown w-100">
          <template #button-content>
            <span class="dropdownlabel clr-bold-grey fw-normal font-14">
              <span class="mr-1 fw-medium">Category:</span>
              {{ categoryLabel }}
            </span>
            <div class="icon clr-bold-grey">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/>
              </svg>
            </div>
          </template>
          <b-dropdown-item
            v-for="category in categoryOptions"
            :key="category.id"
            @click="selectedCategory = category"
            :active="selectedCategory === category"
            class="font-14"
          >
            {{ typeof category === 'string' ? category : category.name }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </div>

    <small v-if="rows">
      <pagination :rows.sync="rows" :filters="filters" class="ticket-pagination" @update:rows="handlePaginationUpdate" />
    </small>

    <!-- Tickets Table -->
    <div class="table-responsive clientsData-wrap mt-2 mb-0">
      <table class="table" v-if="!isTableSkeleton">
        <thead>
          <tr>
            <td>S.N.</td>
            <td>Issue Details</td>
            <td>Submitter Details</td>
            <td>Comments</td>
            <td>Status</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tickets" :key="row.id">
            <td>{{ (current_page - 1) * page_size + index + 1 }}</td>
            <td>
              <div class="issue-category font-13 clr-black fw-semibold d-inline-flex align-items-center justify-content-center mb-2 badgecontainer">
                {{ row.category_name }}
              </div>
              <div class="issue-title clr-title">
                <strong>Title:</strong> {{ row.title }}
              </div>
            </td>
            <td>
              <div class="submitter-name clr-title fw-semibold lh-base font-14">
                {{ row.submitter_name }}
              </div>
              <div class="submitter-email clr-bold-grey lh-base">
                {{ row.submitter_email }}
              </div>
            </td>
            <td>
              <div class="comment-count fw-medium">{{ row.comments_count }}</div>
            </td>
            <td>
              <div :class="[row.status === 'Closed' ? 'closeissue-status' : 'issue-status','d-inline-flex align-items-center justify-content-center badgecontainer fw-medium']">
                {{ row.status }}
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <router-link :to="{ name: 'TicketDetail', params: { ticketId: row.id, ticketType: ticketType} }" target="_blank">
                  <span class="action_icon" v-tooltip="'View Details'">
                    <i class="fas fa-eye"></i>
                  </span>
                </router-link>
                <button v-if="tabIndex==1 && row.status === 'Open'" class="btn btn-danger" @click="closeTicket(row.id)">Close</button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="tickets.length==0">
          <tr>
            <td colspan="5" class="text-center">No matching records found.</td>
          </tr>
        </tbody>
      </table>
      <b-skeleton-table
        v-else
        :rows="5"
        :columns="5"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
    </div>

    <!-- Pagination -->
    <small v-if="rows">
      <pagination
        :rows.sync="rows"
        :filters="filters"
        class="ticket-pagination"
        @update:rows="handlePaginationUpdate"
      />
    </small>
  </b-card-text>
</template>

<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import EventBus from "@/main";

export default {
  name: "TicketListing",
  props: {
    tabIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      statusOptions: ["All", "Open", "Closed"],
      selectedStatus: "All",
      categoryOptions: ["All"],
      selectedCategory: "All",
      searchTerm: "",
      isAssigned: 0,
      rows: [],
      pageSize: 10,
      ticketType: "created",
      isTableSkeleton: false,
      isFilterSkeleton: false,
      searchDebounce: null,
      current_page: 1,
      page_size: 10
    };
  },
  computed: {
    categoryLabel() {
      return typeof this.selectedCategory === "string"
        ? this.selectedCategory
        : this.selectedCategory?.name || "Select";
    },
    filters() {
      const filters = {
        assigned_to_me: this.isAssigned,
        // page_size: 2
      };

      // Status filter
      if (this.selectedStatus && this.selectedStatus !== "All") {
        const statusMap = { Open: 1, Closed: 2 };
        filters.status = statusMap[this.selectedStatus] || this.selectedStatus;
      }

      // Category filter
      if (this.selectedCategory && this.selectedCategory !== "All") {
        filters.category =
          typeof this.selectedCategory === "string"
            ? this.selectedCategory
            : this.selectedCategory.name;
      }

      // Search filter
      if (this.searchTerm) {
        filters.submitter_name = this.searchTerm;
      }

      return filters;
    },
    tickets() {
      if (this.rows && Array.isArray(this.rows.data)) {
        return this.rows.data;
      }
      if (this.rows?.data?.data) {
        return this.rows.data.data;
      }
      return [];
    }
  },
  mounted() {
    this.isFilterSkeleton = true;
    this.isAssigned = this.tabIndex === 1 ? 1 : 0;
    this.ticketType = this.tabIndex === 1 ? "assigned" : "created";
    this.getCategories();
    this.getTickets();
    EventBus.$on("load-ticket-list", () => this.getTickets());
  },
  watch: {
    selectedStatus() {
      this.getTickets(1, 'status');
    },
    selectedCategory() {
      this.getTickets(1, 'cateogry');
    },
    searchTerm(searchVal) {
      clearTimeout(this.searchDebounce);

      if (searchVal.length > 0 && searchVal.length < 3) return;

      this.searchDebounce = setTimeout(() => {
        this.getTickets(1, 'search');
      }, 800);
    },
  },
  methods: {
    getCategories() {
      Api.get("tickets/categories")
        .then((res) => {
          if (res.data?.data && Array.isArray(res.data.data)) {
            this.categoryOptions = ["All", ...res.data.data];
          }
        })
        .catch(err => console.error("API Error:", err));
    },
    getTickets(page = 1, type="default") {
      this.isTableSkeleton = true;
      const url = `tickets?${Helper.objToUrlParams({ ...this.filters, page_size: this.pageSize, page })}`;
      Api.get(url)
        .then((res) => {
          this.rows = res.data.data || { data: [] };
        })
        .catch(err => { console.error(err); this.rows = { data: [] }; })
        .finally(() => {
          this.isTableSkeleton = false;
          this.isFilterSkeleton = false;
          this.$emit('enableNextTab', false);
        });
    },
    handlePaginationUpdate(newData) {
      this.rows = newData?.data || { data: [] };
      this.current_page = newData.data.current_page;
      this.page_size = newData.data.per_page;
    },
    closeTicket(ticketId) {
      const url = `tickets/${ticketId}/close`;
      this.$confirm({
        title: "Close Group Ticket",
        message: `Do you want to close this ticket?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            Api.put(url)
              .then((res) => {
                this.getTickets();
                this.$notify(res.data.message, "Success");
                this.$emit('loadStats');
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "Error");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    }
  },
  beforeDestroy() {
    EventBus.$off("load-ticket-list", this.getTickets);
  }
};
</script>

<style>
.custom-scrollable-dropdown {
  max-height: 190px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.25rem 0;
}
</style>